import { useLocation } from "react-router-dom"
import { getRouteFromLocation, RouteWithParams } from "../../navigation/routes"
import useAppManifest from "../use-app-manifest"

export function useRoute<Key extends string = string>(): RouteWithParams<Key> {
  const location = useLocation()
  const manifest = useAppManifest()
  return getRouteFromLocation(location, manifest)
}
